/* eslint-disable react/prop-types */
import { useEffect, useRef } from "react";

const REACTIONS = [
	{ emoji: "\ud83d\udc4d", name: "Like", value: "like" },
	{ emoji: "\u2764\ufe0f", name: "Love", value: "love" },
	{ emoji: "\ud83c\udf89", name: "Celebrate", value: "celebrate" },
	{ emoji: "\ud83d\ude02", name: "Haha", value: "haha" },
	{ emoji: "\ud83d\ude2e", name: "Wow", value: "wow" }
];

interface ReactionPickerProps {
	onReact: (reaction: string) => void;
	onClose: () => void;
	autoFocus?: boolean;
}

const ReactionPicker = ({
	onReact,
	onClose,
	autoFocus = false
}: ReactionPickerProps) => {
	const firstButtonRef = useRef<HTMLButtonElement>(null);

	useEffect(() => {
		if (autoFocus) firstButtonRef.current?.focus();
	}, [autoFocus]);

	return (
		<div
			role="menu"
			aria-label="Reactions"
			className="absolute bottom-full left-0 mb-2 z-10"
		>
			<div className="flex items-center gap-1 bg-white rounded-full shadow-lg border border-border px-2 py-1.5">
				{REACTIONS.map((r, i) => (
					<button
						key={r.value}
						ref={i === 0 ? firstButtonRef : undefined}
						type="button"
						role="menuitem"
						aria-label={r.name}
						className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-subtle focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary transition-colors text-lg"
						onClick={(e) => {
							e.stopPropagation();
							onReact(r.value);
							onClose();
						}}
					>
						<span aria-hidden="true">{r.emoji}</span>
					</button>
				))}
			</div>
		</div>
	);
};

export { REACTIONS };
export default ReactionPicker;
